import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  if (id)
    return `/v1/companies/${auth.getCurrentUser().company_id}/vehicles/${id}`;
  else return `/v1/companies/${auth.getCurrentUser().company_id}/vehicles`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateVehicleType(data) {
  return http.post(`/v1/vehicles/${data.id}/change-type`, data);
}


export function updateSingle(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateSingleStatus(supplier) {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/vehicles/${
      supplier.id
    }/status`
  );
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}

export function getSingleVehicle(supplierId, companyId) {
  return http.get(`/v1/companies/${companyId}/vehicles/${supplierId}`);
}

export function getAccountCompany(accountId) {
  return http.get(`/v1/get-company/vehicle/${accountId}`);
}

export function getLedgerAccountCompany(accountId) {
  return http.get(`/v1/get-ledger-account-company/vehicle/${accountId}`);
}
